import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export const TRANSPORT = {
  customer_collects: "Customer collects",
  we_deliver: "We deliver",
  we_collect: "We collect",
  we_deliver_collect: "We deliver and collect",
};

const inputCls = "w-full px-3 py-2 border border-zinc-300 rounded-none text-sm focus:outline-none focus:ring-2 focus:ring-brand";

export const YesNo = ({ value, onChange, testid }) => (
  <div className="flex border border-zinc-300 w-fit" data-testid={testid}>
    {[true, false].map((v) => (
      <button type="button" key={String(v)} onClick={() => onChange(v)} data-testid={`${testid}-${v ? "yes" : "no"}`}
        className={`px-4 py-1.5 text-sm font-bold transition-colors ${value === v ? (v ? "bg-emerald-600 text-white" : "bg-zinc-800 text-white") : "bg-white text-zinc-500 hover:bg-zinc-100"}`}>
        {v ? "Yes" : "No"}
      </button>
    ))}
  </div>
);

export const HireBillingDialog = ({ order, onClose, onSaved }) => {
  const [form, setForm] = useState({ po_received: false, po_number: "", invoiced: false });
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (order) setForm({ po_received: order.po_received, po_number: order.po_number || "", invoiced: order.invoiced });
  }, [order]);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch(`/hire-orders/${order.id}/billing`, form);
      toast.success("Hire order updated");
      onSaved();
      onClose();
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!order} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-none sm:max-w-md" data-testid="hire-billing-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl font-black tracking-tighter">PO &amp; Invoice</DialogTitle>
          {order && <p className="text-sm text-zinc-500">{order.equipment_name} — {order.customer}</p>}
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-bold text-zinc-900 block mb-1">PO received</label>
            <YesNo value={form.po_received} onChange={(v) => setForm({ ...form, po_received: v })} testid="billing-po" />
          </div>
          {form.po_received && (
            <div>
              <label className="text-sm font-bold text-zinc-900 block mb-1">PO number</label>
              <input value={form.po_number} maxLength={100} onChange={(e) => setForm({ ...form, po_number: e.target.value })} data-testid="billing-po-number" className={inputCls} />
            </div>
          )}
          <div>
            <label className="text-sm font-bold text-zinc-900 block mb-1">Invoiced</label>
            <YesNo value={form.invoiced} onChange={(v) => setForm({ ...form, invoiced: v })} testid="billing-invoiced" />
          </div>
        </div>
        <DialogFooter>
          <button onClick={save} disabled={saving} data-testid="billing-save-button"
            className="bg-brand text-white rounded-full font-bold tracking-tight hover:bg-brand-dark transition-colors px-6 py-2 disabled:opacity-60">
            {saving ? "Saving…" : "Save"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
